<template>
  <el-dialog  title="指派" append-to-body  :visible.sync="dialog" width="1200px"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div >
           <div ref="searchBox">
        <el-form :inline="true" :model="derverFrom" ref="derverFrom" class="demo-form-inline" label-width="86px" size="mini">
        <div class="searchBox inpBox" >
            <div>
              <el-form-item label="司机姓名:" prop="dirverName">
                <el-input  placeholder=""   type="text" v-model="derverFrom.name" ></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder=""   type="text" v-model="derverFrom.identityNo" ></el-input>
              </el-form-item>
               <!-- <el-form-item label="联系电话:" prop="dirverMobile">
                <el-input  placeholder="" v-model="derverFrom.mobile"></el-input>
              </el-form-item> -->
               <el-form-item>
              <el-button type="primary" @click="SJsearchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="resetForm('derverFrom')">重置</el-button>
              </el-form-item>
            </div>
        </div>
       </el-form>
       </div>
       <div >
        <el-table :data="sijiList"  ref="xzdz" height="500" v-loading="loading1"     highlight-current-row  border  >
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text"  @click="SJZPfn(scope.row)" size="mini">指派</el-button>
            </template>
          </el-table-column>
        <el-table-column prop="name" width="120" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
         <!-- <el-table-column property="auditStatus" label="审核状态" >
            <template scope="scope">
              {{[ "待审核", "审核通过", "审核驳回" ][scope.row.auditStatus-1]}}
            </template>
          </el-table-column> -->
          <el-table-column property="identityNo" label="身份证号" width="200">
            <template scope="scope">
              <p v-if="scope.row.tenantId!=tenantCode">
                {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
              </p>
              <p v-else>{{scope.row.identityNo}}</p>
            </template>
          </el-table-column>
        <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
        <el-table-column property="driverClassify" label="司机所属" >
          <template scope="scope">
            {{scope.row.tenantId!=tenantCode?'市场司机':'自家司机'}}
          </template>
        </el-table-column>
      </el-table>
      </div>
       <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="derverChange"
        @current-change="derverCurrentChange"
        :current-page="derverFrom.pageNo"
        :page-sizes="[25,50,100,200,1000]"
        :page-size="derverFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="SJtotal">
      </el-pagination>
    </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">关闭</el-button>
        <!-- <el-button type="primary" @click="saveFn">确 定</el-button> -->
      </span>
       <el-dialog append-to-body title="选择车辆" :visible.sync="carMark" @close="closeDialog1"  :close-on-click-modal="false" width="900px" center>
        <!-- 内容 -->
        <div>
          <el-form :inline="true" :model="derverFrom" ref="derverFrom" class="demo-form-inline" label-width="86px" size="mini">
            <div class="searchBox inpBox" >
                <div>
                  <el-form-item label="车牌号:" prop="vhcNo">
                    <el-input  placeholder="" v-model="carFrom.vhcNo"></el-input>
                  </el-form-item>
                   <!-- <el-form-item label="车辆所属:" prop="vhcClassify">
                    <el-select placeholder="请选择" v-model="carFrom.vhcClassify">
                      <el-option
                        v-for="item in vehicleSS"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                </el-form-item> -->
                  <el-form-item>
                  <el-button type="primary" @click="carSearchFn">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="resetForm('derverFrom')">重置</el-button>
                  </el-form-item>
                </div>
            </div>
          </el-form>
          <!-- 表格数据 -->
          <div class="tableQiye">
            <!-- 表格 -->
            <div>
              <el-table :data="carList" ref="table" v-loading="loading1" bordersize="mini"
                  class="table" height="380px" style="width: 100%"   center  border  :row-class-name="tableRowClassName" >
                <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="carOk(scope.row)" size="mini">选择车辆</el-button>
                  </template>
                </el-table-column>
               <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
               <!-- <el-table-column property="auditStatus" label="审核状态" >
                <template scope="scope">
                  {{[ "待审核", "审核通过", "审核驳回" ][scope.row.auditStatus-1]}}
                </template>
              </el-table-column> -->
                <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
                <el-table-column prop="weight" width="100"  :show-overflow-tooltip="true"  label="载重(吨)"></el-table-column>
                <el-table-column prop="energyName"  width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
                <el-table-column prop="standardsName" width="80" :show-overflow-tooltip="true" label="排放标准"></el-table-column>
                <!-- <el-table-column property="vhcClassify" label="车辆所属" >
                  <template scope="scope">
                    {{scope.row.tenantId!=tenantCode?'市场车辆':'自家车辆'}}
                  </template>
                </el-table-column> -->
                <el-table-column property="vehicleTenantName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
         <el-pagination background
          @size-change="carChange"
          @current-change="carCurrentChange"
          :current-page="carFrom.pageNo"
          :page-sizes="[25,50,100,200,1000]"
          :page-size="carFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="carTotal">
        </el-pagination>
        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="carMark=false">关闭</el-button>
        </div>
      </el-dialog>
   </el-dialog>
</template>

<script>
import { cDlist, getCVehicleExtAllByDriverId } from '@/api/vgs-driver2.0'
import { dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  name: 'editDistribution',
  props: {

  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      dateFormat: dateFormat,
      tenantCode: '', // 租户code
      dialog: false,
      loading1: false,
      activeName: 'qiyun', // tab切换
      addFrom: {},
      // 司机列表
      derverFrom: {
        pageNo: 1,
        pageSize: 50
      },
      sijiList: [],
      SJtotal: 0,
      // 车辆列表
      carMark: false,
      vehicleSS: [
        { value: '', label: '请选择' },
        { value: 1, label: '市场车辆' },
        { value: 2, label: '自家车辆' }
      ],
      carFrom: {
        pageNo: 1,
        pageSize: 50
      },
      carList: [],
      carTotal: 0
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
    this.tenantCode = localStorage.getItem('tenantCode')
  },
  methods: {
    SJZPfn (row) {
      this.$set(this.addFrom, 'driverIdentityNo', row.identityNo)
      this.$set(this.addFrom, 'driverName', row.name)
      this.$set(this.addFrom, 'driverMobile', row.mobile)
      this.carFrom.driverId = row.id
      this.carFrom.pageNo = 1
      getCVehicleExtAllByDriverId(this.carFrom).then(res => {
        console.log(res)
        this.carMark = true
        this.carList = res.list
        this.carTotal = res.total
      }).catch(res => {
        console.log(res, (res))
      })
    },
    carOk (row) {
      this.$set(this.addFrom, 'vhcNo', row.vhcNo)
      this.$emit('zhipaiSave', this.addFrom)
    },
    SJsearchFn () {
      if (this.derverFrom.name || this.derverFrom.identityNo) {
        this.getDerverList()
      } else {
        this.$alert('请输入司机姓名或身份证号进行查询', '系统提示')
      }
    },
    getDerverList () {
      this.loading1 = true
      cDlist(this.derverFrom).then(res => {
        this.loading1 = false
        this.sijiList = res.list
        this.SJtotal = res.total
      })
    },
    derverChange (val) {
      this.derverFrom.pageSize = val
      this.getDerverList()
    },
    derverCurrentChange (val) {
      this.derverFrom.pageNo = val
      this.getDerverList()
    },
    // 车辆列表
    carSearchFn () {
      this.getCarlist()
    },
    getCarlist () {
      this.loading1 = true
      getCVehicleExtAllByDriverId(this.carFrom).then(res => {
        this.loading1 = false
        this.carList = res.list
        this.carTotal = res.total
      })
    },
    carChange (val) {
      this.carFrom.pageSize = val
      this.getCarlist()
    },
    carCurrentChange (val) {
      this.carFrom.pageNo = val
      this.getCarlist()
    },

    // 司机得车辆加背景色
    tableRowClassName ({ row, rowIndex }) {
      if (row.relId) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    // 重置
    resetForm (formName) {
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.huocheFrom = {
        pageNo: 1,
        pageSize: 50,
        allocatedStatus: 2
      }
      this.$set(this.carFrom, 'vhcNo', '')
    },
    closeDialog () {
      this.$emit('destroy')
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.$set(this.carFrom, 'vhcNo', '')
      this.$set(this.carFrom, 'vhcClassify', '')
    },
    closeDialog1 () {
      this.$set(this.carFrom, 'vhcNo', '')
      this.$set(this.carFrom, 'vhcClassify', '')
    }

  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-table .warning-row {
    background: #c4fbd2!important;
  }
</style>
